import emailjs from '@emailjs/browser';

// EmailJS configuration
// Sign up at https://www.emailjs.com/ to get these credentials
const EMAILJS_CONFIG = {
  serviceId: 'service_kunjvihari',  // You'll need to replace this with your EmailJS service ID
  templateId: 'template_appointment', // You'll need to replace this with your EmailJS template ID
  publicKey: 'YOUR_PUBLIC_KEY'  // You'll need to replace this with your EmailJS public key
};

// Initialize EmailJS
export const initEmailJS = () => {
  emailjs.init(EMAILJS_CONFIG.publicKey);
};

// Send appointment confirmation email
export const sendAppointmentEmail = async (appointmentData) => {
  try {
    const templateParams = {
      to_email: 'info@kunjvihariimpex.com',
      customer_name: appointmentData.name,
      customer_email: appointmentData.email,
      customer_phone: appointmentData.phone,
      company: appointmentData.company || 'Not provided',
      appointment_date: appointmentData.date,
      appointment_time: appointmentData.time,
      appointment_type: appointmentData.type,
      visitor_count: appointmentData.visitorCount,
      special_requests: appointmentData.specialRequests || 'None',
      subject: `Factory Visit Request - ${appointmentData.name} - ${appointmentData.date}`
    };

    const response = await emailjs.send(
      EMAILJS_CONFIG.serviceId,
      EMAILJS_CONFIG.templateId,
      templateParams
    );

    console.log('Email sent successfully:', response);
    return { success: true, response };
  } catch (error) {
    console.error('Email sending failed:', error);
    return { success: false, error };
  }
};

// Send contact form email
export const sendContactEmail = async (contactData) => {
  try {
    const templateParams = {
      to_email: 'info@kunjvihariimpex.com',
      customer_name: contactData.name,
      customer_email: contactData.email,
      customer_phone: contactData.phone,
      subject: contactData.subject || 'General Inquiry',
      message: contactData.message,
      inquiry_type: contactData.inquiryType || 'General'
    };

    const response = await emailjs.send(
      EMAILJS_CONFIG.serviceId,
      'template_contact', // You'll need a separate template for contact form
      templateParams
    );

    console.log('Contact email sent successfully:', response);
    return { success: true, response };
  } catch (error) {
    console.error('Contact email sending failed:', error);
    return { success: false, error };
  }
};

